"use strict";

import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import { withCarouselNav, syncCarouselNavVisibility } from './carousel-nav';

const SELECTOR = '[data-gallery-carousel]';
const GAP_REM = 0.5;

function getGap() {
	return parseFloat(getComputedStyle(document.documentElement).fontSize) * GAP_REM;
}

function initGalleryCarousel() {
	const spaceBetween = getGap();

	document.querySelectorAll(SELECTOR).forEach(function (el) {
		if (el.swiper) {
			return;
		}

		const swiper = new Swiper(el, withCarouselNav(el, {
			modules: [FreeMode],
			slidesPerView: 1.2,
			spaceBetween,
			grabCursor: true,
			freeMode: {
				enabled: true,
				momentumRatio: 0.85,
				momentumVelocityRatio: 0.85,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		}));

		syncCarouselNavVisibility(swiper);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initGalleryCarousel, { once: true });
} else {
	initGalleryCarousel();
}
